import React from "react";
import { NavLink } from "react-router-dom";
import { TiHomeOutline } from "react-icons/ti";
// import { CgProfile } from "react-icons/cg";
// import { FiPlusCircle } from "react-icons/fi";
import FootLogo from "./assets/kancaroo-and-xpress-logo-450x117.svg";

const Footer = () => {
  return (
    <>

<div className="container-fluid desk-footer">
        <div className="container">
          <div className="row">
            <div className="col col-12 col-md-6">
              <a href="/all-booking">
                <img
                  src={FootLogo}
                  width={270}
                  height={117}
                  loading="lazy"
                  alt="Represents our brand's identity and commitment to quality."
                />
              </a>
            </div>
            <div className="col col-12 col-md-6 pt-3 pt-md-0">
              <p className="sub-heading foot-heading">
                © All rights reserved. Kancaroo <br /> A UNIT OF ICM LOGISTICS
                PVT LTD
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid p-0 mob-footer d-none">
        <div className="container">
          <ul>
            <li>
              <NavLink to="/all-booking">
                <TiHomeOutline /> <br /> All Booking
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

    </>
  );
};

export default Footer;
